<template>
  <div class="scio-workspace-page">
    <WorkspacePageHeader eyebrow="Support" title="Documentation">
      <template #context><span class="scio-workspace-pill"><span class="scio-workspace-pill-value">User guide</span></span></template>
      <template #actions>
        <router-link :to="{ name: 'project-list' }" class="scio-se-nav-action" title="Open programme catalogue" aria-label="Open programme catalogue">
          <img src="/icons/scio-chevron-left-01.svg" alt="" aria-hidden="true" class="h-4 w-4" /><span class="sr-only">Open programme catalogue</span>
        </router-link>
      </template>
    </WorkspacePageHeader>
    <main class="bg-white">
      <div class="mx-auto max-w-5xl px-5 py-10 sm:px-8 lg:px-10 lg:py-14">
        <header class="max-w-3xl">
          <p class="scio-text-data scio-weight-semibold uppercase tracking-[0.16em] text-neutral-500">Scio user guide</p>
          <h1 class="mt-2 text-3xl font-semibold tracking-tight text-neutral-950 sm:text-4xl">Build a model you can explain</h1>
          <p class="mt-4 text-base leading-7 text-neutral-600">Follow the learning path from programme setup and scenario creation through scheduling, logistics, model runs and governed decisions.</p>
        </header>

        <div class="mt-12 border-t border-neutral-200">
          <section v-for="group in documentationTopics" :key="group.group" class="grid gap-5 border-b border-neutral-200 py-9 md:grid-cols-[9rem_minmax(0,1fr)]">
            <h2 class="scio-text-data scio-weight-semibold uppercase tracking-[0.16em] text-neutral-400">{{ group.group }}</h2>
            <div class="divide-y divide-neutral-200">
              <router-link v-for="topic in group.topics" :key="topic.slug" :to="{ name: topic.routeName }" class="group grid gap-2 py-5 first:pt-0 last:pb-0 sm:grid-cols-[minmax(0,1fr)_2rem]">
                <span><span class="block text-lg font-semibold text-neutral-950 group-hover:underline">{{ topic.title }}</span><span class="mt-1 block scio-text-body leading-6 text-neutral-600">{{ topic.summary }}</span></span>
                <span class="text-right text-lg text-neutral-400 transition group-hover:translate-x-1 group-hover:text-neutral-900" aria-hidden="true">→</span>
              </router-link>
            </div>
          </section>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import WorkspacePageHeader from "@/common/components/WorkspacePageHeader.vue";
import { documentationTopics } from "@/core/documentation/documentationTopics";

export default { name: "DocumentationIndexPage", components: { WorkspacePageHeader }, data() { return { documentationTopics }; } };
</script>
